import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";
import styled from "styled-components";

export const StepsFooterRow = styled.div`
  display: grid;
  gap: 1em;
  grid-template-columns: max-content max-content;
  justify-content: space-between;

  p {
    margin: 0;
  }
`;

export const StepsFooterPrevious = styled.div``;

export const StepsFooterNext = styled.div`
  display: contents;
`;

export const StepsFooterSpan = styled.div`
  grid-column: 1 / -1;
`;

export interface IStepsFooterProps {
  isFirstStep: boolean;
  onPreviousStepClick: () => void;
  children?: ReactNode;
}

export const StepsFooter = ({
  isFirstStep,
  onPreviousStepClick,
  children,
}: IStepsFooterProps) => {
  return (
    <StepsFooterRow>
      <StepsFooterPrevious>
        {!isFirstStep && (
          <p>
            <Button color="secondary" onClick={onPreviousStepClick}>
              <FormattedMessage id="steps.previous" />
            </Button>
          </p>
        )}
      </StepsFooterPrevious>
      <StepsFooterNext className="text-right">{children}</StepsFooterNext>
    </StepsFooterRow>
  );
};
